import React from "react";
import Modal from "./Modal";
import { Translate } from "react-redux-i18n";
import QRCode from "qrcode.react";
import "./styles/ModalStoreContacts.css";

function escapeVCard(value) {
  return String(value)
    .replace(/\\/g, "\\\\")
    .replace(/;/g, "\\;")
    .replace(/,/g, "\\,")
    .replace(/\n/g, "\\n");
}

function buildContactVCard(marketstore) {
  const name = (marketstore?.Name || "").trim();
  const email = (marketstore?.Email || "").trim();
  const phone = (marketstore?.Phone || "").trim();
  const url = marketstore?.Id
    ? `${window.location.origin}/marketstore/show/${marketstore.Id}`
    : "";

  if (!name && !email && !phone) {
    return "";
  }

  const lines = ["BEGIN:VCARD", "VERSION:3.0"];

  if (name) {
    lines.push(`FN:${escapeVCard(name)}`);
    lines.push(`ORG:${escapeVCard(name)}`);
  }
  if (email) {
    lines.push(`EMAIL;TYPE=INTERNET:${escapeVCard(email)}`);
  }
  if (phone) {
    lines.push(`TEL;TYPE=CELL:${escapeVCard(phone)}`);
  }
  if (url) {
    lines.push(`URL:${escapeVCard(url)}`);
  }

  lines.push("END:VCARD");
  return lines.join("\n");
}

function ContactField({ label, value, href }) {
  const hasValue = Boolean(value?.trim());

  return (
    <div className="store-contact-modal-field">
      <p className="store-contact-modal-field-label">{label}</p>
      {hasValue ? (
        href ? (
          <a className="store-contact-modal-field-link" href={href}>
            {value}
          </a>
        ) : (
          <p className="store-contact-modal-field-value">{value}</p>
        )
      ) : (
        <p className="store-contact-modal-field-value store-contact-modal-field-empty">
          —
        </p>
      )}
    </div>
  );
}

function ModalStoreContacts({ isOpen, onClose, marketstore }) {
  const email = marketstore?.Email?.trim() || "";
  const phone = marketstore?.Phone?.trim() || "";
  const vCard = buildContactVCard(marketstore);
  const hasContactData = Boolean(email || phone);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={<Translate value="footer_contacts" />}
    >
      <div className="store-contact-modal">
        {marketstore?.Name && (
          <div className="store-contact-modal-hero">
            <h2 className="store-contact-modal-name">{marketstore.Name}</h2>
          </div>
        )}

        <div className="store-contact-modal-fields">
          <ContactField
            label={<Translate value="profile_email" />}
            value={email}
            href={email ? `mailto:${email}` : null}
          />
          <ContactField
            label={<Translate value="profile_phone" />}
            value={phone}
            href={phone ? `tel:${phone.replace(/\s/g, "")}` : null}
          />
        </div>

        {vCard && (
          <div className="store-contact-modal-qr">
            <p className="store-contact-modal-qr-label">
              <Translate value="marketstore_contact_qr_label" />
            </p>
            <div className="store-contact-modal-qr-canvas">
              <QRCode value={vCard} size={168} level="M" includeMargin />
            </div>
            <p className="store-contact-modal-qr-hint">
              <Translate value="marketstore_contact_qr_hint" />
            </p>
          </div>
        )}

        {!hasContactData && (
          <p className="store-contact-modal-qr-hint">
            <Translate value="marketstore_contact_empty" />
          </p>
        )}

        <div className="store-contact-modal-footer">
          <button
            type="button"
            className="store-contact-modal-close"
            onClick={onClose}
          >
            <Translate value="ok" />
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ModalStoreContacts;
